import { connect } from 'react-redux';
import { fetchKBSuggestionsSuccessAction } from 'epics/model/kb-suggestion';
import type { State as AppState } from 'state';
import { fetchPortalUploadMediaTokenAction } from 'state/actions/portal';
import { proformaFormDirtyAction } from 'state/actions/request-create';
import {
    getProjectId,
    getServiceDeskId,
    getMediaApiUploadToken as getPortalMediaApiUploadToken,
    getMediaApiError,
} from 'state/selectors/portal';
import { getProformaSettingsWithoutContext } from 'state/selectors/proforma-form-settings';
import { getProformaTemplateForm, getIsProformaFormDirty } from 'state/selectors/request-create';
import { withAnalyticsEvents, withAnalyticsContext } from '@atlaskit/analytics-next';
import { FormCreateAppContainer } from '@atlassian/help-center-common-component/fields/proforma/form-create-app/form-create-app';
import type {
    OwnProps,
    StateProps,
    DispatchProps,
} from '@atlassian/help-center-common-component/fields/proforma/form-create-app/types';

export default connect<StateProps, DispatchProps, OwnProps, AppState>(
    (state: AppState, { portalId, requestTypeId }: OwnProps) => ({
        backendSettingsWithoutContext: getProformaSettingsWithoutContext(state),
        serviceDeskId: getServiceDeskId(state, portalId),
        proformaTemplateForm: getProformaTemplateForm(state, portalId, requestTypeId),
        projectId: getProjectId(state, portalId),
        mediaApiUploadToken: getPortalMediaApiUploadToken(state, portalId),
        mediaApiError: getMediaApiError(state, portalId),
        proformaFormIsDirty: getIsProformaFormDirty(state, portalId, requestTypeId),
    }),
    {
        fetchPortalUploadMediaToken: fetchPortalUploadMediaTokenAction,
        fetchKBSuggestionsSuccess: fetchKBSuggestionsSuccessAction,
        setProformaFormDirtyAction: proformaFormDirtyAction,
    }
)(withAnalyticsContext({ componentName: 'FormCreateAppContainer' })(withAnalyticsEvents()(FormCreateAppContainer)));
